import {createStyles, Theme} from "@material-ui/core";
import {beigeColor, PURPLE_200, styleColors} from "src/main.style";

const spinnerShadow = [
  `${styleColors.blackAlpha63} 1.5em 0 0 0`,
  `${styleColors.blackAlpha63} 1.1em 1.1em 0 0`,
  `${styleColors.blackAlpha63} 0 1.5em 0 0`,
  `${styleColors.blackAlpha63} -1.1em 1.1em 0 0`,
  `${styleColors.blackAlpha63} -1.5em 0 0 0`,
  `${styleColors.blackAlpha63} -1.1em -1.1em 0 0`,
  `${styleColors.blackAlpha63} 0 -1.5em 0 0`,
  `${styleColors.blackAlpha63} 1.1em -1.1em 0 0`,
].join(", ");

const spinnerWebkitShadow = [
  `${styleColors.blackAlpha63} 1.5em 0 0 0`,
  `${styleColors.blackAlpha63} 1.1em 1.1em 0 0`,
  `${styleColors.blackAlpha63} 0 1.5em 0 0`,
  `${styleColors.blackAlpha63} -1.1em 1.1em 0 0`,
  `${styleColors.blackAlpha45} -1.5em 0 0 0`,
  `${styleColors.blackAlpha45} -1.1em -1.1em 0 0`,
  `${styleColors.blackAlpha63} 0 -1.5em 0 0`,
  `${styleColors.blackAlpha63} 1.1em -1.1em 0 0`,
].join(", ");

export const PrivateRouterStyle = (theme: Theme) => createStyles({
  "@global": {
    ".loadingCircle": {
      zIndex: 0,
      position: "absolute",
      top: "-17.125rem",
      left: "-30.75rem",
      width: "56.25rem",
      height: "56.25rem",
      borderRadius: "56.25rem",
      backgroundColor: beigeColor,
    },
    ".loadingTopRightCorner": {
      position: "absolute",
      top: 0,
      right: 0,
    },
    ".loading": {
      position: "fixed",
      zIndex: 999,
      overflow: "visible",
      margin: "auto",
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
    },
    ".loading:before": {
      content: "''",
      display: "block",
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: PURPLE_200,
    },
    ".loading:not(:required)": {
      font: "0/0 a",
      color: styleColors.transparent,
      textShadow: "none",
      backgroundColor: styleColors.transparent,
      border: 0,
    },
    ".loading:not(:required):after": {
      content: "''",
      display: "block",
      fontSize: "10px",
      width: "1em",
      height: "1em",
      marginTop: "-0.5em",
      marginLeft: "-0.5em",
      position: "absolute",
      left: "50%",
      top: "50%",
      WebkitAnimation: "spinner 1500ms infinite linear",
      MozAnimation: "spinner 1500ms infinite linear",
      msAnimation: "spinner 1500ms infinite linear",
      OAnimation: "spinner 1500ms infinite linear",
      animation: "spinner 1500ms infinite linear",
      borderRadius: "0.5em",
      WebkitBoxShadow: spinnerWebkitShadow,
      boxShadow: spinnerShadow,
    },
    "@keyframes spinner": {
      "0%": {
        WebkitTransform: "rotate(0deg)",
        MozTransform: "rotate(0deg)",
        msTransform: "rotate(0deg)",
        OTransform: "rotate(0deg)",
        transform: "rotate(0deg)",
      },
      "100%": {
        WebkitTransform: "rotate(360deg)",
        MozTransform: "rotate(360deg)",
        msTransform: "rotate(360deg)",
        OTransform: "rotate(360deg)",
        transform: "rotate(360deg)",
      },
    },
  },
  privateRouter: {
    height: '100%',
    width: '100%',
    display: 'flex',
  },
  loginLoadingRecovery: {
    position: "fixed",
    zIndex: 1005,
    right: "24px",
    bottom: "max(20px, env(safe-area-inset-bottom))",
    left: "24px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "24px",
  },
  loginLoadingDelayMessage: {
    color: styleColors.greyDark2,
    fontSize: "1rem",
    lineHeight: 1.5,
    textAlign: "center",
  },
  loginLoadingBackButton: {
    minWidth: "144px",
    minHeight: "48px",
    padding: "10px 32px",
    border: `2px solid ${styleColors.greyDark2}`,
    color: styleColors.greyDark2,
    fontSize: "1rem",
    fontWeight: 600,
    textTransform: "none",
    "&:hover": {
      border: `2px solid ${styleColors.greyDark2}`,
      backgroundColor: styleColors.lightGreyOverlay,
    },
    "&:focus-visible": {
      outline: `2px solid ${styleColors.greyDark2}`,
      outlineOffset: "3px",
    },
  },
  ratingDialogTitle: {
    textAlign: "center",
    fontSize: "1.25rem",
    fontWeight: 700,
    color: styleColors.primaryTextBlack87,
  },
  ratingDialogContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(2),
    textAlign: "center",
    color: styleColors.greyDark2,
    fontSize: "1rem",
    lineHeight: 1.5,
  },
  ratingStars: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "nowrap",
    gap: theme.spacing(0.5),
    width: "100%",
  },
  ratingStarButton: {
    padding: theme.spacing(0.5),
    flex: "0 0 auto",
    "& svg": {
      fontSize: "2.25rem",
    },
  },
  ratingStarSelected: {
    color: "#f2b01e",
  },
  ratingStarUnselected: {
    color: styleColors.greyMedium2,
  },
  ratingActions: {
    display: "flex",
    justifyContent: "center",
    gap: theme.spacing(1.5),
    width: "100%",
  },
  ratingLaterButton: {
    borderColor: styleColors.greyMedium2,
    color: styleColors.greyDark2,
    backgroundColor: styleColors.transparent,
    "&:hover": {
      borderColor: styleColors.greyDark2,
      backgroundColor: styleColors.lightGreyOverlay,
    },
  },
});



// WEBPACK FOOTER //
// ./src/router/private.router.style.ts